import { LogInIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { isKeyEnter } from '@/util/util';

import styles from '../DetailsSection.module.scss';

type StartingNodeStepProps = { nodeName?: string; onGoToNode: () => void };

/**
 * Standalone debug step shown when the turn was opened by the brain's starting
 * node (force-triggered on the first message of a session). Rendered as a
 * canonical step row — gray "enter" icon + a single line "Conversation starts at
 * {node}" with the node name as a deeplink — so spacing and the connector line
 * match sibling rows. Shared by the auth and non-auth Details sections.
 */
export const StartingNodeStep = ({ nodeName, onGoToNode }: StartingNodeStepProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.step}>
      <div className={styles.title}>
        <LogInIcon size={16} color="var(--muted-foreground)" />
        <div className="text-sm leading-5 text-muted-foreground">
          {t('try_it.details.conversation_starts_at')}{' '}
          <span
            className={styles.link}
            role="link"
            tabIndex={0}
            onClick={onGoToNode}
            onKeyDown={(e) => isKeyEnter(e) && onGoToNode()}
          >
            {nodeName}
          </span>
        </div>
      </div>
      <div className={styles.details}></div>
    </div>
  );
};
